import styled from 'styled-components';

export const StyledTimeOfDayIcon = styled.span`
   display: inline-flex;
   flex-shrink: 0;
   align-items: center;
   justify-content: center;
   width: 24px;
   height: 24px;

   svg {
      width: 100%;
      height: 100%;
      fill: ${({ theme }) => theme.primary};
   }
`;

StyledTimeOfDayIcon.displayName = 'StyledTimeOfDayIcon';
